import React from "react"
import { Grid, Chip, Typography } from "@material-ui/core"

import {
	AccessTime as ClockIcon,
	PlayCircleOutline as ActuationIcon
} from "@material-ui/icons"

import { ShortChatBotFlow } from "@/services/ChatBotFlow"

import { fullDatetime } from "@/utils/time"

import useStyles from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemDetails/styles"
import { colors } from "@/styles/colors"

type FlowListItemDetailsProps = {
	chatBotFlow: Pick<ShortChatBotFlow, "id" | "name" | "active" | "updated_at" | "consolidated_data" | "tag" | "board">
}

export type FlowStatusConfig = {
	statusLabel: string
	chipBackgroundColor: string
}

type FlowStatusTypeToStatusConfig = Record<"enabled" | "disabled", FlowStatusConfig>

const FLOW_STATUS_TO_STATUS_PROPS: FlowStatusTypeToStatusConfig = {
	disabled: {
		statusLabel: "Desativado",
		chipBackgroundColor: colors.red[100]
	},
	enabled: {
		statusLabel: "Ativado",
		chipBackgroundColor: colors.green[200]
	}
}

const FlowListItemDetails: React.FC<FlowListItemDetailsProps> = (props) => {
	const { chatBotFlow } = props

	const lastEditDate = fullDatetime(new Date(chatBotFlow?.updated_at))
	const lastTriggerText = chatBotFlow?.consolidated_data?.last_use_date ? fullDatetime(new Date(chatBotFlow?.consolidated_data?.last_use_date)) : "Ainda não houve"

	const flowStatus: keyof typeof FLOW_STATUS_TO_STATUS_PROPS = chatBotFlow.active ? "enabled" : "disabled"
	const flowStatusConfig = FLOW_STATUS_TO_STATUS_PROPS[flowStatus]

	const classes = useStyles({ ...flowStatusConfig })

	return (
		<Grid container alignItems="center">
			<Grid item sm={12} lg={4}>
				<Chip label={flowStatusConfig.statusLabel} className={classes.chip} />
			</Grid>
			<Grid item sm={12} lg={8}>
				<Grid container direction="column" spacing={1}>
					<Grid item xs={12}>
						<Grid container alignItems="center" justifyContent="flex-start">
							<Grid item>
								<Grid container alignItems="center" justifyContent="flex-start">
									<ClockIcon className={classes.clockIcon} />
								</Grid>
							</Grid>
							<Grid item>
								<Typography variant="body1" className={classes.listItemData}>Última alteração: {lastEditDate}</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Grid item xs={12}>
						<Grid container alignItems="center" justifyContent="flex-start">
							<Grid item>
								<Grid container alignItems="center" justifyContent="flex-start">
									<ActuationIcon className={classes.clockIcon} />
								</Grid>
							</Grid>
							<Grid item>
								<Typography variant="body1" className={classes.listItemData}> Último acionamento: {lastTriggerText}</Typography>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default FlowListItemDetails
